import { DOM } from '@antv/l7-utils';
import { Control, PositionType } from "./baseControl";
export { Logo };
export default class Logo extends Control {
  getDefault() {
    return {
      position: PositionType.BOTTOMLEFT,
      name: 'logo',
      href: 'https://l7.antv.antgroup.com/',
      img: 'https://gw.alipayobjects.com/mdn/rms_816329/afts/img/A*GRb1TKp4HcMAAAAAAAAAAAAAARQnAQ'
    };
  }
  onAdd() {
    const container = DOM.create('div', 'l7-control-logo');
    this.setLogoContent(container);
    return container;
  }
  onRemove() {
    return null;
  }
  setOptions(option) {
    super.setOptions(option);
    if (this.checkUpdateOption(option, ['img', 'href'])) {
      DOM.clearChildren(this.container);
      this.setLogoContent(this.container);
    }
  }
  setLogoContent(container) {
    const {
      href,
      img
    } = this.controlOption;
    const imgDOM = DOM.create('img');
    imgDOM.setAttribute('src', img);
    imgDOM.setAttribute('aria-label', 'AntV logo');
    DOM.setUnDraggable(imgDOM);
    if (href) {
      const anchorDOM = DOM.create('a', 'l7-control-logo-link');
      anchorDOM.target = '_blank';
      anchorDOM.href = href;
      anchorDOM.rel = 'noopener nofollow';
      anchorDOM.setAttribute('rel', 'noopener nofollow');
      anchorDOM.appendChild(imgDOM);
      container.appendChild(anchorDOM);
    } else {
      container.appendChild(imgDOM);
    }
  }
}